// ConfirmModal.jsx
import React from 'react';
import '../styles/ConfirmModal.css';

const ConfirmModal = ({ onConfirm, onCancel }) => (
  <div className="confirm-modal-overlay">
    <div className="confirm-modal-content">
      <h4>¿Confirmás la validación del recibo?</h4>
      <p>
        Una vez validado, no podrás realizar ningún reclamo. Estás aceptando que el
        recibo está correctamente emitido.
      </p>
      <div className="buttonContent">
        <button
          className="buttonContent_button cancel"
          onClick={onCancel}
        >
          Cancelar
        </button>
        <button
          className="buttonContent_button valid"
          onClick={onConfirm}
        >
          Validar
        </button>
      </div>
    </div>
  </div>
);

export default ConfirmModal;
